<!-- vertical-layout -->
<vertical-layout [isLoggedIn]="authService.isLoggedIn()"></vertical-layout>
<!-- / vertical-layout -->
